import { render } from "./vendor-dashboard.vue?vue&type=template&id=85255d54&scoped=true"
import script from "./vendor-dashboard.vue?vue&type=script&lang=js"
export * from "./vendor-dashboard.vue?vue&type=script&lang=js"

import "./vendor-dashboard.vue?vue&type=style&index=0&id=85255d54&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85255d54"]])

export default __exports__